// extracted by mini-css-extract-plugin
module.exports = {"list":"tabs_list__BVDe5","list__item":"tabs_list__item__KZ3cZ","text":"tabs_text__fvFyF","text--active":"tabs_text--active__93quH"};